import { z } from 'zod';
/** Marker for "no params / query / body". */
export const None = z.undefined();
/** Defines an endpoint; omitted params/query/body become `None`. */
export function ep(def) {
    return {
        ...def,
        params: (def.params ?? None),
        query: (def.query ?? None),
        body: (def.body ?? None),
    };
}
/** Path params declared in a path string. */
export const pathParams = (path) => [...path.matchAll(/:([A-Za-z0-9_]+)/g)].map((m) => m[1] ?? '');
//# sourceMappingURL=endpoint-def.js.map